import { useTranslation } from "react-i18next"
import ReactMarkdown from "react-markdown"

import { BookOpen, Cloud, Globe, Play, Telescope, Upload } from "@/components/icons"
import { buttonVariants } from "@/components/ui/button-variants"
import { cn } from "@/lib/utils"

function M365Icon() {
  return (
    <div className="inline-flex flex-col items-center justify-center leading-none">
      <Cloud className="size-4" strokeWidth={1.75} />
      <span className="-mt-0.5 text-[10px] font-semibold tracking-tight">365</span>
    </div>
  )
}

export function DemoResearchPlan() {
  const { t } = useTranslation()
  const { t: tResearch } = useTranslation("", { keyPrefix: "training.ai-explorer.research-agent" })

  return (
    <div className="w-full space-y-3 sm:max-w-2xl">
      <div className="bg-background rounded-lg border p-3 sm:p-4">
        <div className="prose dark:prose-invert prose-h4:mb-2 prose-h4:mt-4 prose-h4:text-base prose-h4:font-semibold first:prose-h4:mt-0 prose-p:my-2 prose-ol:my-2 prose-ol:space-y-1">
          <ReactMarkdown>{tResearch("demo_research_plan")}</ReactMarkdown>
        </div>
      </div>
      <section className="bg-background flex flex-col gap-2 rounded-lg border px-2 py-2 sm:flex-row sm:justify-between">
        <section className="flex items-center justify-center gap-1 sm:justify-start">
          <button
            className={cn(buttonVariants({ size: "icon", variant: "icon" }), "size-7")}
            type="button"
          >
            <Upload className="size-5" />
          </button>
          <button
            className={cn(buttonVariants({ size: "icon", variant: "icon" }), "size-7")}
            type="button"
          >
            <Globe className="size-5" />
          </button>
          <button
            className={cn(buttonVariants({ size: "icon", variant: "icon" }), "size-7")}
            type="button"
          >
            <M365Icon />
          </button>
          <button
            type="button"
            className={cn(
              buttonVariants({ size: "icon", variant: "icon" }),
              "border-foreground bg-secondary text-secondary-foreground size-7 border"
            )}
          >
            <Telescope className="size-5" />
          </button>
          <button
            className={cn(buttonVariants({ size: "icon", variant: "icon" }), "size-7")}
            type="button"
          >
            <BookOpen className="size-5" />
          </button>
        </section>
        <section className="flex items-center justify-center sm:justify-end">
          <button
            className={cn(
              buttonVariants({
                size: "md",
                variant: "default",
              }),
              "gap-2 text-sm sm:text-base"
            )}
          >
            <Play className="size-4" />
            {t("questioninput.start_research")}
          </button>
        </section>
      </section>
    </div>
  )
}
